import React from 'react';

interface LockIconProps {
  className?: string;
}

/** Figma pick-card lock (12×12). Color via `className` (e.g. text-background). */
export const LockIcon: React.FC<LockIconProps> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    className={className}
    aria-hidden
  >
    <path
      d="M5.625 7.5C5.625 7.29289 5.79289 7.125 6 7.125C6.20711 7.125 6.375 7.29289 6.375 7.5C6.375 7.70711 6.20711 7.875 6 7.875C5.79289 7.875 5.625 7.70711 5.625 7.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.375 4.875V3C3.375 2.30381 3.65156 1.63613 4.14384 1.14384C4.63613 0.651562 5.30381 0.375 6 0.375C6.69619 0.375 7.36387 0.651562 7.85616 1.14384C8.34844 1.63613 8.625 2.30381 8.625 3V4.875H9.40909C9.79084 4.875 10.125 5.17642 10.125 5.57812V10.1719C10.125 10.5736 9.79084 10.875 9.40909 10.875H2.59091C2.20916 10.875 1.875 10.5736 1.875 10.1719V5.57812C1.875 5.17642 2.20916 4.875 2.59091 4.875H3.375ZM4.67417 1.67417C5.02581 1.32254 5.50272 1.125 6 1.125C6.49728 1.125 6.97419 1.32254 7.32583 1.67417C7.67746 2.02581 7.875 2.50272 7.875 3V4.875H4.125V3C4.125 2.50272 4.32254 2.02581 4.67417 1.67417ZM6.375 8.56099C6.81195 8.40655 7.125 7.98983 7.125 7.5C7.125 6.87868 6.62132 6.375 6 6.375C5.37868 6.375 4.875 6.87868 4.875 7.5C4.875 7.98983 5.18805 8.40655 5.625 8.56099V9C5.625 9.20711 5.79289 9.375 6 9.375C6.20711 9.375 6.375 9.20711 6.375 9V8.56099Z"
      fill="currentColor"
    />
  </svg>
);
